export default {
  error: {
    error_occured: "Une erreur est survenue",
    reload_page: "Rafraichir la page",
    back: "Revenir en arrière",
    message: {
      not_found: "La page que vous avez demandée n'a pas été trouvée !",
      unavailable: "Service non disponible !",
      not_authorized_title: "Accès interdit",
      not_authorized: "Vous n'êtes pas autorisé à accéder à cette page",
      file_not_authorized: "Vous n'êtes pas autorisé à télécharger un fichier",
      unauthenticated: "Vous devez vous authentifier pour accéder à cette page",
    },
    go_back_to_home: "Revenir à l'accueil",
    support_message:
      "Une erreur est survenue lors de l’opération. Nos équipes sont mobilisées pour résoudre le problème. Merci de votre compréhension.",
    login_attempts:
      "Il vous reste {attempts} essais. Au-delà, votre accès sera suspendu pendant 5 minutes par mesure de sécurité.",
    login_blocked:
      "Votre compte est temporairement bloqué suite à plusieurs tentatives infructueuses. Veuillez patienter 5 minutes avant de réessayer.",
  },
  warning: {
    title: "Attention : ",
  },
};
